module.exports = __webpack_public_path__ + "static/media/infoJumbo2.e712624b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/bodor/images/infoJumbo2.jpg
// module id = 186
// module chunks = 0